<div class="mb-4">
  <div class="banner px-4 py-3 w-100 d-flex align-items-center">
    <ds-icon class="margin-right-sm icon-info" [icon]="Icons.CircleInfo" [iconStyle]="IconStyles.Regular"></ds-icon>
    {{ 'task_updated_to_status' | translate | translateCut: 0 }}<!--
    -->&nbsp;<ds-link [rtLink]="taskLink">{{ task.taskProjectId }}</ds-link><!--
    -->&nbsp;{{ 'task_updated_to_status' | translate | translateCut: 1 }}<!--
    -->&nbsp;<span class="task-status">{{ statusPolicy.labelKey(task.status) | translate }}</span
    >{{ 'task_updated_to_status' | translate | translateCut: 2 }}
    <button
      ds-button
      [variant]="DsButtonVariants.microAction"
      [microActionIcon]="Icons.XMark"
      [attr.aria-label]="'action_close' | translate"
      class="ms-auto"
      (click)="closeBanner.emit()"
    ></button>
  </div>
</div>
